import React from 'react';
import ReactDOM from 'react-dom';
import { detect, BrowserInfo } from 'detect-browser';

import { App } from './components/App/App';
import { setAppConfig } from './config/config';
import { AppConfig } from './types/config/config.types';
import { isUnsupportedBrowser } from './isUnsupportedBrowser';

if (isUnsupportedBrowser(detect() as BrowserInfo)) {
  const unsupportedBrowserBannerEl = document.getElementById('browser-unsupported');
  if (unsupportedBrowserBannerEl != null) {
    unsupportedBrowserBannerEl.style.display = 'block';
  }
}

(async function() {
  try {
    const clientConfig = await (await fetch('/config.json')).json();
    const { apiUrl } = clientConfig;
    const configData = await fetch(`${apiUrl}/config.json`);
    const appConfig = {
      ...(await configData.json()) as AppConfig,
      ...clientConfig
    };
    console.log('appConfig', appConfig);

    setAppConfig(appConfig);

    ReactDOM.render(<App />, document.getElementById('root'));
  } catch (e) {
    console.error('App config could not be loaded');
    console.error(e);
  }
})();
